
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component({})
  export default class AppInputMoney extends Vue {
    $refs: any;
    formattedValue: string;
    keyCode: number;

    @Prop([Number]) value!: number | null;
    @Prop([Number]) min!: number;
    @Prop([Number]) max!: number;
    @Prop({ default: ''}) placeholder!: string;
    @Prop([Boolean]) disabled!: boolean;
    @Prop([Boolean]) disableMountedFocus!: boolean;
    @Prop([Boolean]) isClearable!: Boolean;
    @Prop([String]) append!: String;
    @Prop([Boolean]) isProposedPrice!: Boolean;
    @Prop([String]) suffixSymbol!: string;

    mounted() {
      if (!this.disableMountedFocus) {
        this.$refs.displayedInput.focus();
      }
    }

    async onEnterClose() {
      if(this.isProposedPrice) await this.$store.dispatch('dialog/closeDialog', { blockName: 'pageCart', dialogName: 'priceManagement'});
    }

    get displayedValue(): string | null {
      return this.value === null ? null : this.formattedValue;
    }

    set displayedValue (value: string | null) {
      if (value === null) {
        this.$emit('input', null);
        return;
      }

      const displayedInput: any = this.$refs.displayedInput;
      const input: any = displayedInput.$refs.input;
      let caretPosition = input.selectionStart ? input.selectionStart : 0;

      const minusIndex = value.indexOf('-');
      if (minusIndex !== -1) {
        value = value.slice(0, minusIndex) + value.slice(minusIndex + 1);
        caretPosition -= 1;
      }

      if (this.displayedValue && caretPosition < this.displayedValue.length - 1 && this.displayedValue[caretPosition] === ' ') {
        if (this.keyCode === 46) {  //delete key
          value = value.slice(0, caretPosition) + value.slice(caretPosition + 1);
        }
        if (this.keyCode === 8) {  //backspace key
          value = value.slice(0, caretPosition - 1) + value.slice(caretPosition);
          caretPosition -= 2;
        }
        if (caretPosition < 0) caretPosition = 0;
      }

      if (this.displayedValue && caretPosition < this.displayedValue.length - 1 && this.displayedValue[caretPosition + 1] === ' ' && caretPosition === 0) {
        if (this.keyCode === 46) {
          value = value.slice(0, caretPosition) + value.slice(caretPosition + 1);
        } else if (this.keyCode === 8) {
          value = value.slice(caretPosition);
          caretPosition = 1;
        }
      }

      this.formattedValue = value;
      let oldLength = this.formattedValue.length;

      this.$nextTick(() => {
        let newLength = this.formattedValue.length;
        if (newLength > oldLength) {
          caretPosition += newLength - oldLength;
        } else if (newLength < oldLength) {
          caretPosition -= oldLength - newLength;
        }
        displayedInput.currentValue = this.formattedValue;
        let sum = _.toNumber(_.replace(value, / /g, ''));
        this.$emit('input', sum);
        this.$nextTick(() => input.setSelectionRange(caretPosition, caretPosition));
      });
    }

    get isZero (): boolean {
      return !!this.value;
    }

    constructor () {
      super();
      this.formattedValue = _.isNumber(this.value) ? _.toString(this.value) : '';
    }

    rememberKeyCode (keyCode) {
      this.keyCode = keyCode;
    }

    forceUpdate () {
      this.$nextTick(() => {
        this.displayedValue = _.isNumber(this.value) ? _.toString(this.value) : null;
      });
    }

    onChange (value) {
      this.$nextTick(() => {
        this.displayedValue = value !== '' ? value : null;
        if (!_.isUndefined(this.min) && !_.isUndefined(this.max)) {
          if (this.min <= _.toNumber(_.replace(value, / /g, '')) && _.toNumber(_.replace(value, / /g, '')) <= this.max) {
            this.displayedValue = value !== '' ? value : null;
          }
          else {
            this.displayedValue = "0";
          }
        }
      });
    }

    onKeyDown ({ keyCode }) {
      this.rememberKeyCode(keyCode);
      this.$emit('keydown', keyCode);
    }
  }
